import Cookie from 'js-cookie';
const getGAId = function ($ = jQuery) {
  // Binding GA Client ID to session
  session.ga_client_id = Cookie('_ga');
};

export { getGAId };
